import { LazyLoader } from "@NextSkyTheme/lazy-load";

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];
    const currentProductID = productJson.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    const productJson = JSON.parse(prodData.innerHTML);
    const storedProducts = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          new LazyLoader(".image-lazy-load");
        })
        .finally(() => {})
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    this.main = document.querySelector(".main-product-section");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector("[data-product-buy-zone]");
    const footer = document.querySelector("footer");
    if (!primaryBtn) return;

    // Audit 360 v2 (M1) : expose la hauteur occupee en bas d'ecran par la barre d'achat
    // (et la barre mobile en dessous) pour placer le bouton WhatsApp juste au-dessus.
    let offsetFrame = null;
    const updateStickyOffset = () => {
      offsetFrame = null;
      if (!_this.classList.contains("show-sticky-cart")) return;
      // Position reelle du haut de la barre. Pendant l'animation d'apparition, la barre est
      // translatee hors ecran : ces mesures aberrantes sont ignorees (transitionend relance).
      const rect = _this.getBoundingClientRect();
      const occupied = Math.round(window.innerHeight - rect.top);
      if (rect.top <= 0 || occupied <= 0 || occupied > window.innerHeight * 0.5) return;
      document.documentElement.style.setProperty("--sdp-sticky-cart-offset", occupied + "px");
    };
    const scheduleStickyOffset = () => {
      if (offsetFrame === null) offsetFrame = requestAnimationFrame(updateStickyOffset);
    };
    window.addEventListener("scroll", scheduleStickyOffset, { passive: true });
    window.addEventListener("resize", scheduleStickyOffset, { passive: true });
    _this.addEventListener("transitionend", scheduleStickyOffset);

    const show = () => {
      _this.classList.add("show-sticky-cart");
      document.documentElement.classList.add("show-sticky-cart-active");
      scheduleStickyOffset();
      setTimeout(scheduleStickyOffset, 350);
    };
    const hide = () => {
      _this.classList.remove("show-sticky-cart");
      document.documentElement.classList.remove("show-sticky-cart-active");
    };

    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        if (footer) {
          const footerRect = footer.getBoundingClientRect();
          if (footerRect.top < window.innerHeight - 80) {
            hide();
            return;
          }
        }
        if (entry.isIntersecting) hide();
        else show();
      },
      { threshold: 0, rootMargin: "0px 0px 0px 0px" }
    );
    io.observe(primaryBtn);

    window.addEventListener(
      "scroll",
      () => {
        if (!footer) return;
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 80) hide();
      },
      { passive: true }
    );
  }
}
customElements.define("sticky-add-cart", StickyAddCart);

const infoGallerySlide = () => {
  const gallery = document.querySelectorAll(".info-gallery__card");
  gallery.forEach((e) => {
    e.addEventListener("mouseover", (event) => {
      const currentTarget = event.currentTarget;
      if (!currentTarget.classList.contains("active")) {
        gallery.forEach((el) => {
          el.classList.remove("active");
        });
        currentTarget.classList.add("active");
      }
    });
  });
};
document.addEventListener("shopify:section:load", function () {
  infoGallerySlide();
});
infoGallerySlide();
